import { vmInsight as vm } from "../../constants/actionTypes";

const INITIAL_STATE = {
  vmInsightListData: [],
  vmInsightListError: {},
  vmInsightDetails: {},
  vmInsightDetailListError: {},
  loader: false,
};

const vmInsightReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case vm.SET_VM_INSIGHT_LIST:
      return {
        ...state,
        vmInsightListData: action?.data,
      };
    case vm.SET_VM_INSIGHT_LIST_ERROR:
      return {
        ...state,
        vmInsightListError: action?.data?.data,
      };
    case vm.SET_VM_INSIGHT_DETAILS_LIST:
      return {
        ...state,
        vmInsightDetails: action?.data,
      };
    case vm.SET_VM_INSIGHT_DETAILS_LIST_ERROR:
      return {
        ...state,
        vmInsightDetailListError: action?.data?.data,
      };
    case vm.SET_VM_INSIGHT_LIST_LOADER:
      return {
        ...state,
        loader: action?.data,
      };

    default:
      return state;
  }
};

export default vmInsightReducer;
